export const SESSION_GET_LIST = 'SESSION_GET_LIST';
export const SESSION_REMOVE = 'SESSION_REMOVE';
